module.exports = __webpack_public_path__ + "static/light-4c7aa983110e541c922d989395416322.png";